import React from 'react';
import clsx from 'clsx';
import { CardArt } from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

const FocusableCardArt = ({
  imgUrl,
  imgAlt,
  linkUrl,
  onClick,
  ariaLabel,
  custStyles,
  options = {
    hasHoverShadow: true,
    sizeToParent: false
  }
}) => {
  const stylesObj = typeof custStyles === 'object' ? custStyles : styles;
  return (
    <a
      className={clsx(stylesObj.cardArtLink, {
        [styles.sizeToParent]: options?.sizeToParent
      })}
      href={linkUrl}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <CardArt
        tabIndex="-1"
        className={stylesObj.cardArt}
        src={imgUrl}
        alt={imgAlt ? imgAlt : ''}
        $withShadowHover={options?.hasHoverShadow}
      />
    </a>
  );
};

export default React.memo(FocusableCardArt);
